// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.source-select[data-v-6393723e] {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  padding: 50px;
  display: flex;
  background-color: var(--bg-color-all);
  border-radius: 10px;
}
.source-select .close[data-v-6393723e] {
  position: absolute;
  right: 24px;
  top: 18px;
  border-radius: 50%;
  font-size: 22px;
  color: white;
  cursor: pointer;
  -webkit-app-region: no-drag;
  z-index: 9999;
}
.source-select .sources[data-v-6393723e] {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-template-rows: repeat(auto-fit, minmax(auto, 180px));
  -webkit-app-region: drag;
  pointer-events: bounding-box;
}
.source-select .sources .source[data-v-6393723e] {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: 5px;
  border-radius: 5px;
  padding: 5px;
  cursor: pointer;
  border: 1px solid gray;
  -webkit-app-region: no-drag;
  -webkit-user-select: none;
}
.source-select .sources .source[data-v-6393723e]:hover {
  background-color: #4375d0;
}
.source-select .sources .source .img-wrapper[data-v-6393723e] {
  width: 100%;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex: 1;
}
.source-select .sources .source .img-wrapper img[data-v-6393723e] {
  object-fit: contain;
  width: 100%;
}
.source-select .sources .source .text[data-v-6393723e] {
  margin: auto;
  margin-top: 5px;
  color: white;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
}
.source-select .sources .source .text span[data-v-6393723e] {
  padding: 0 3px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNew/videoConfSourceSelect.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,yDAAyD;EACzD,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,OAAO;AACT;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;AACb","sourcesContent":[".source-select[data-v-6393723e] {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n  padding: 50px;\n  display: flex;\n  background-color: var(--bg-color-all);\n  border-radius: 10px;\n}\n.source-select .close[data-v-6393723e] {\n  position: absolute;\n  right: 24px;\n  top: 18px;\n  border-radius: 50%;\n  font-size: 22px;\n  color: white;\n  cursor: pointer;\n  -webkit-app-region: no-drag;\n  z-index: 9999;\n}\n.source-select .sources[data-v-6393723e] {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  grid-template-rows: repeat(auto-fit, minmax(auto, 180px));\n  -webkit-app-region: drag;\n  pointer-events: bounding-box;\n}\n.source-select .sources .source[data-v-6393723e] {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  margin: 5px;\n  border-radius: 5px;\n  padding: 5px;\n  cursor: pointer;\n  border: 1px solid gray;\n  -webkit-app-region: no-drag;\n  -webkit-user-select: none;\n}\n.source-select .sources .source[data-v-6393723e]:hover {\n  background-color: #4375d0;\n}\n.source-select .sources .source .img-wrapper[data-v-6393723e] {\n  width: 100%;\n  overflow: hidden;\n  height: 100%;\n  display: flex;\n  flex: 1;\n}\n.source-select .sources .source .img-wrapper img[data-v-6393723e] {\n  object-fit: contain;\n  width: 100%;\n}\n.source-select .sources .source .text[data-v-6393723e] {\n  margin: auto;\n  margin-top: 5px;\n  color: white;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 100%;\n}\n.source-select .sources .source .text span[data-v-6393723e] {\n  padding: 0 3px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
